import { action, makeAutoObservable } from 'mobx';
import { makePersistable, clearPersistedStore } from 'mobx-persist-store';

import env from 'env';

import { persistConfig } from 'store/config';
import { Theme, type BreadcrumbLink, type JsonDataItem, type MenuState } from 'types';

const menuDefaultState = {
  openKeys: [],
  selectedKeys: [],
};

class RootStore {
  token: string = '';
  isTrainingMode: boolean = env.THEME === Theme.Training;
  user: JsonDataItem | null = null;
  notepad: { title: string; description: string }[] = [{ title: '', description: '' }];
  fieldsAmount: number = 1;

  breadcrumbs: BreadcrumbLink[] | null = null;
  menu: MenuState = menuDefaultState;
  customerProfile: JsonDataItem | null = null; // TODO: Create a Profile store if need to store more profile-related data
  job: JsonDataItem | null = null; // TODO: Create a Job store if need to store more job-related data

  constructor() {
    makeAutoObservable(this);
    void makePersistable(this, {
      name: 'root-store',
      properties: ['token', 'user', 'notepad', 'breadcrumbs', 'menu', 'customerProfile', 'job'],
      ...persistConfig,
    });
  }

  @action
  setToken = (token: string) => {
    this.token = token;
  };

  @action
  setUser = (user: JsonDataItem) => {
    this.user = user;
  };

  @action
  setNotepad = (notepad: { title: string; description: string }[]) => {
    this.notepad = notepad;
  };

  setFieldsAmount = (amount: number) => {
    this.fieldsAmount = amount;
  };

  @action
  setBreadcrumbs = (config: BreadcrumbLink[] | null) => {
    this.breadcrumbs = config;
  };

  @action
  setMenu = (menuState: MenuState) => {
    this.menu = { ...this.menu, ...menuState };
  };

  @action
  setCustomerProfile = (profile: JsonDataItem | null) => {
    this.customerProfile = profile;
  };

  @action
  setJob = (job: JsonDataItem | null) => {
    this.job = job;
  };

  @action
  resetAppData = () => {
    this.token = '';
    this.isTrainingMode = env.THEME === Theme.Training;
    this.user = null;
    this.breadcrumbs = null;
    this.menu = menuDefaultState;
    this.customerProfile = null;
    this.job = null;
    this.notepad = [];

    void clearPersistedStore(this);
  };
}

export default new RootStore();
